import { render, staticRenderFns } from "./ConfigFormularios.vue?vue&type=template&id=d8738100&scoped=true&lang=pug&"
import script from "./ConfigFormularios.vue?vue&type=script&lang=js&"
export * from "./ConfigFormularios.vue?vue&type=script&lang=js&"
import style0 from "./ConfigFormularios.vue?vue&type=style&index=0&id=d8738100&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8738100",
  null
  
)

export default component.exports